import { render, staticRenderFns } from "./TimelineEventLoading.vue?vue&type=template&id=d1ec162a&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports